import type { AppStartListening } from "@/data/listenerMiddleware";
import {
  accessCodeVerificationResolved,
  lockWorkSession,
  verifyWorkSession,
} from "@/features/authority";

/**
 * Start authority related listeners.
 */
export function startAuthorityListeners(startListening: AppStartListening) {
  startAccessCodeVerificationListener(startListening);
}

/**
 * Turn an `accessCodeVerificationResolved` event into the matching session
 * lock/unlock dispatch. Lives here rather than in the access-code modal hook
 * so that the hook doesn't dispatch Redux actions directly from an Apollo
 * `onCompleted` callback (the modal hook just emits the resolution event
 * after the mutation awaits).
 */
function startAccessCodeVerificationListener(
  startListening: AppStartListening
) {
  startListening({
    actionCreator: accessCodeVerificationResolved,
    effect: ({ payload }, listenerApi) => {
      if (payload.verified) {
        listenerApi.dispatch(verifyWorkSession());
      } else {
        listenerApi.dispatch(lockWorkSession());
      }
    },
  });
}
